import { DateTime } from 'luxon';

const getCheckoutsArchiveDefaultFilters = () => {
  const startOfLastWeek = DateTime.now().toUTC().startOf('week').minus({ weeks: 1 });
  const endOfLastWeek = startOfLastWeek.endOf('week').startOf('day');
  return `?fromDate=${startOfLastWeek.toISODate()}&toDate=${endOfLastWeek.toISODate()}`;
};

export { getCheckoutsArchiveDefaultFilters };
